import { useState, useEffect } from 'react';
import styles from './DigitalClock.module.css';

const DigitalClock = ({ className = '' }) => {
  const [time, setTime] = useState(() => getCurrentTime());

  useEffect(() => {
    const interval = setInterval(() => {
      const newTime = getCurrentTime();
      setTime(prev => (prev !== newTime ? newTime : prev));
    }, 10000); 
  
    return () => clearInterval(interval);
  }, []);
  

  function getCurrentTime() {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    // const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  return (
    <div className={`${styles.clockWrapper} ${className}`}>
      <span className={styles.clockText}>{time}</span>
    </div>
  );
};

export default DigitalClock;